<template>
  <div class="page-tea-buy">
    <div class="tit">我的订单</div>
    <div class="tip"><span class="t">温馨提示：</span>商品下单后，一般会在3~5日之内送达。实际到达时间请以物流信息为准。物流订单号我们将通过短信提示你。</div>
    <div class="form-wrap">
      <div class="form-item">
        <div class="field">收件人姓名</div>
        <div class="cont">
          <el-input v-model="form.username" placeholder="请输入收件人姓名" />
        </div>
        <div class="rig-des"></div>
      </div>
      <div class="form-item">
        <div class="field">收件人手机号</div>
        <div class="cont">
          <el-input v-model="form.phone" placeholder="请输入收件人手机号" />
        </div>
        <div class="rig-des">
          <span v-if="send">验证码已发送</span>
          <span v-else class="sended" @click="sendMess">发送验证码</span>
        </div>
      </div>
      <div class="form-item">
        <div class="field"></div>
        <div class="cont">
          <el-input v-model="form.code" placeholder="请输入验证码" />
        </div>
        <div class="rig-des check-code">
          <i class="el-icon-circle-check"></i>
          <i class="el-icon-circle-close"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="field">收货地址</div>
        <div class="cont mobile-select">
          <van-field
            v-model="form.addressAreaM"
            is-link
            readonly
            placeholder="请选择省市区"
            @click="mobileShow = true"
          />
          <el-input v-model="form.addressInfo" placeholder="请输入详细楼号、单元、门牌号等" />
        </div>
        <div class="cont pc-select">
          <el-cascader
            v-model="form.addressAreaP"
            placeholder="请选择省市区"
            :options="selectOptions"
            @change="pcSelect"
          >
          </el-cascader>
          <el-input v-model="form.addressInfo" placeholder="请输入详细楼号、单元、门牌号等" />
        </div>
      </div>
    </div>

    <div class="tea-buy-wrap">
      <img class="tea-img" src="@/assets/images/tea_img.jpg" alt="">
      <div class="tea-info">
        <div class="tea-tit">大谷运明前茶（黄山毛峰）</div>
        <div class="tea-more">
          <div class="count">库存：70/套</div>
          <div class="price-select">
            <span class="price">价格：￥998.00/套</span>
            <el-input-number class="select" v-model="form.num" size="mini" :min="1" />
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-fukuan-info">
      <div class="caca">
        <div class="fu-wrap">
          <div class="field">商品金额：</div>
          <div class="price">￥1996.00</div>
        </div>
        <div class="fu-wrap top">
          <div class="field">运费：</div>
          <div class="price">包邮</div>
        </div>
      </div>
      <div class="fu-wrap ca-ca">
        <div class="field">应付总额：</div>
        <div class="price red">￥1996.00</div>
      </div>
    </div>

    <div class="submit">
      <el-button type="danger">提交订单</el-button>
    </div>

    <van-popup v-model="mobileShow" round position="bottom">
      <van-cascader
        v-model="mobileCascaderVal"
        title="请选择所在地区"
        :field-names="fieldNames"
        :options="selectOptions"
        @close="mobileShow = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'buy',
    data () {
      return {
        send: false,
        form: {
          username: '',
          phone: '',
          code: '',
          addressAreaM: '',
          addressAreaP: '',
          addressInfo: '',
          num: 1
        },

        // 移动端级联选择器
        mobileShow: false,
        mobileCascaderVal: '',
        fieldNames: {
          text: 'label'
        },
        // 选项列表，children 代表子选项，支持多级嵌套
        selectOptions: [
          {
            label: '浙江省',
            value: '330000',
            children: [
              {
                label: '杭州市',
                value: '330100',
                children: [
                  { label: 'xx县', value: '330101' },
                  { label: 'yy县', value: '330102' },
                ]
              }
            ],
          },
          {
            label: '江苏省',
            value: '320000',
            children: [
              {
                label: '南京市',
                value: '320100',
                children: [
                  { label: 'aa县', value: '320101' },
                  { label: 'bb县', value: '320102' },
                ]
              }
            ],
          },
        ],
      }
    },
    methods: {
      sendMess () {
        this.send = true
      },

      // m
      // 全部选项选择完毕后，会触发 finish 事件
      onFinish ({ selectedOptions }) {
        this.mobileShow = false
        this.form.addressAreaM = selectedOptions.map((option) => option.label).join('/')
      },

      // pc
      pcSelect () {}
    }
  }
</script>

<style lang="less" scoped>
  .page-tea-buy {
    padding: @NAVHEIGHT + 10px 10px 10px;
    background: #fff;

    .tit {
      color: #000;
      font-size: 16px;
    }

    .tip {
      margin: 5px;
      padding: 15px;
      font-size: 10px;
      line-height: 18px;
      background: #f5f5f5;
      border-radius: 5px;
    }

    .form-wrap {
      margin-top: 20px;

      .form-item {
        display: flex;
        margin-bottom: 10px;
        line-height: 32px;

        .field {
          flex: 0 0 100px;
          width: 100px;
          color: #4e4e4e;
          font-size: 14px;
        }
        .cont {
          flex: 1;
          margin-right: 10px;

          /deep/.el-input {
            .el-input__inner {
              padding: 0 10px;
            }
          }

          /deep/.van-cell {
            padding: 0 10px;
            line-height: 32px;
            border-radius: 4px;
            border: 1px solid #DCDFE6;

            .van-icon {
              line-height: 32px;
            }
          }

          .el-cascader {
            width: 100%;
          }

          &.mobile-select {
            display: block;
          }
          &.pc-select {
            display: none;
          }
        }
        .rig-des {
          flex: 0 0 80px;
          width: 80px;
          font-size: 12px;
          text-align: center;

          &.check-code {
            font-size: 20px;
            // text-align: left;

            .el-icon-circle-check {
              color: #67C23A;
            }
            .el-icon-circle-close {
              color: #F56C6C;
            }
          }

          .sended {
            color: #42a7f9;
          }
        }
      }
    }

    .tea-buy-wrap {
      display: flex;
      padding: 15px 0;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;

      .tea-img {
        flex-shrink: 0;
        height: 80px;
        line-height: 0;
      }

      .tea-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        color: #4d4d4d;

        .tea-tit {
          font-weight: bold;
        }
        .tea-more {
          font-size: 12px;

          // .count {}
          .price-select {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 5px;

            .price {
              line-height: 28px;
            }

            .select.el-input-number {
              width: 90px;
            }
          }
        }
      }
    }

    .bottom-fukuan-info {
      padding-left: 50%;

      .caca {
        padding: 20px 0;
      }

      .ca-ca {
        padding-top: 20px;
        border-top: 1px solid #e6e6e6;
      }
    }

    .fu-wrap {
      display: flex;
      width: 100%;
      font-size: 14px;
      color: #4d4d4d;
      line-height: 24px;

      .field {
        flex: 0 0 80px;
        text-align: right;
      }

      .price {
        &.red {
          color: #ee3835;
        }
      }
    }

    .submit {
      margin-top: 20px;
      text-align: right;

      .el-button {
        width: 100px;
        background: #ec3935;
      }
    }
  }

  @media screen and (min-width: 1250px) {
    .page-tea-buy {
      width: 1200px;
      margin: 0 auto;
      padding: @NAVHEIGHT + 30px 60px 60px;

      .tit {
        font-size: 24px;
      }

      .tip {
        margin-top: 20px;
        font-size: 16px;
        line-height: 32px;

        .t {
          display: block;
        }
      }

      .form-wrap {
        width: 700px;

        .mobile-select {
          display: none !important;
        }
        .pc-select {
          display: block !important;
        }
      }

      .tea-buy-wrap {
        padding: 60px 0;

        .tea-img {
          height: 225px;
        }

        .tea-info {
          margin-left: 50px;

          .tea-tit {
            font-size: 24px;
          }

          .tea-more {
            font-size: 18px;

            .count {
              margin-bottom: 20px;
            }

            .select.el-input-number {
              width: 130px !important;
            }
          }
        }
      }

      .bottom-fukuan-info {
        padding-left: 800px;
      }

      .fu-wrap {
        font-size: 18px;

        &.top {
          margin-top: 15px;
        }

        .field {
          flex: 0 0 130px;
        }
      }

      .submit {
        margin-top: 50px;

        .el-button {
          width: 200px;
          height: 56px;
          font-size: 24px;
          border-radius: 10px;
        }
      }
    }
  }
</style>
